import { Field, Form, Formik } from "formik";
import AdminFormLayout from "../../components/common/form-layout/AdminFormLayout";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { postApi, putApi } from "../../services/api/globalApi";
import Input from "../../components/common/inputs/Input";
import Button from "../../components/common/button/Button";
import { useEffect, useRef, useState } from "react";
import { categoryValidation } from "../../utils/validation/categoryValidation";
import { useLocation, useNavigate } from "react-router";
import CategoriesSelect from "../../components/common/inputs/CategoriesSelect";
import Select from "../../components/common/inputs/Select";
import { publicImageProps } from "../../services/config";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";

export default function LearnCategory() {
  const location = useLocation();
  const navigate = useNavigate();

  const { utils } = useSelector(utilsState);

  const formHandler = async (values, { resetForm }) => {
    console.log(values);
    const body = {
      ...values,
      image: image,
    };
    try {
      if (location.state) {
        await putApi({
          path: `admin/learnCategories/${location.state?.id}`,
          body: JSON.stringify(body),
        });
        successMessage("دسته بندی با موفقیت ویرایش شد");
      } else {
        await postApi({
          path: "admin/learnCategories",
          body: JSON.stringify(body),
        });
        successMessage("دسته بندی با موفقیت اضافه شد");
      }
      resetForm();
      navigate("/learn-category-list");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };


  useEffect(() => {
    if (location?.state?.image) {
      setImage(location.state.image);
    }
  }, [location.state]);

  const imagesModal = useRef();
  const [image, setImage] = useState("");

  const selectedImages = (item) => {
    console.log(item);
    if (item) {
      setImage(item.name);
      successMessage("عکس اضافه شد.");
    }
  };

  return (
    <AdminFormLayout title={location?.state ? "ویرایش دسته‌بندی آموزش" : "افزودن دسته‌بندی آموزش"} description="نام و تصویر دسته‌بندی آموزش‌ها را تنظیم کنید.">

      <Formik
        enableReinitialize
        initialValues={{
          name: location?.state?.name || "",
          status:
            location?.state?.status ||
            utils?.CATEGORY_STATUS_VALUES[0]?.value ||
            "",
        }}
        validationSchema={categoryValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input name="name" placeholder="نام" label="نام" type="text" />
                {utils ? (
                  <Field
                    as="select"
                    name="status"
                    label="وضعیت"
                    component={Select}
                  >
                    {utils?.CATEGORY_STATUS_VALUES.map((item) => {
                      return <option value={item.value}>{item?.name}</option>;
                    })}
                  </Field>
                ) : null}

                <div className="">
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    عکس
                  </label>
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    <div className="flex flex-wrap items-center gap-2 min-w-0">
                      {image ? (
                        <img
                          {...publicImageProps(image, { variant: "thumb_" })}
                          className="w-20 h-20 shrink-0 rounded-xl border border-gray-200 object-contain bg-gray-50 dark:border-gray-700 dark:bg-gray-800"
                          alt=""
                        />
                      ) : (
                        <p className="text-sm">هنوز تصویری انتخاب نشده است.</p>
                      )}
                      {/* <p className="max-w-12 overflow-hidden">{image || ""}</p> */}
                    </div>
                    <div className="flex flex-wrap items-center gap-2 min-w-0">
                      {image && (
                        <Button
                          type="button"
                          onClick={() => setImage("")}
                          text={"حذف"}
                          color={"danger"}
                        />
                      )}

                      <Button
                        type="button"
                        onClick={() => imagesModal.current.showModal()}
                        text={image ? "ویرایش" : "انتخاب"}
                        color={"success"}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="admin-form-actions">
                  <Button disabled={formik.isSubmitting} loading={formik.isSubmitting}
                    text={location?.state ? "ویرایش" : "افزودن"}
                    type="submit" color="success"
                  />
                  <button type="button" className="admin-form-cancel" onClick={() => navigate("/learn-category-list")}>انصراف</button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <ImagesModal selectedImages={selectedImages} ref={imagesModal} />
    </AdminFormLayout>
  );
}
